// extracted by mini-css-extract-plugin
export default {"launcher":"bf_Ph","launcher__heading":"bf_Pj","launcher__menu-item":"bf_Pk","launcher__options":"bf_Pl","launcher__framework-style__select":"bf_Pm form-control"};